<div class="side-nav-body">

    <div class="profile-actions">
        <button [title]="'common.past_donations' | translate" mat-button class="sm-btn">{{"common.past_donations" | translate}}</button>
    </div>
    <div class="profile-actions">
        <button title="About Us" mat-button class="sm-btn">About Us</button>
    </div>
</div>
